<template>
  <div class="footer">
    <ul class="warp">
      <li>
        <a href="javascript:;" @click="goTop()">首页</a>
        <span>|</span>
        <a href="javascript:;" @click="$router.push(`/bottom/1`)">关于我们</a>
        <span>|</span>
        <a href="javascript:;" @click="$router.push(`/bottom/2`)">推广服务</a>
        <span>|</span>
        <a href="javascript:;" @click="$router.push(`/bottom/3`)">金融服务</a>
        <span>|</span>
        <a href="javascript:;" @click="$router.push(`/bottom/5`)">招聘服务</a>
        <span>|</span>
        <a href="javascript:;" @click="$router.push(`/bottom/4`)">咨询服务</a>
      </li>
      <li class="footer_tip">
        ©2015 TrendBank 势银 浙ICP备14040257号
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    goTop(){
      this.$router.push(`/`);
      window.scrollTo(0,0);
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  box-sizing: border-box;
  height: 66px;
  background: #0c324c;
  padding: 12px 0;
  li {
    color: #fff;
    font-size: 13px;
    height: 18px;
    span {
      width: 6px;
      display: inline-block;
      text-align: center;
    }
    a {
      color: #fff;
    }
  }
  .footer_tip {
    margin-top: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_footer.vue